import React, { Component } from "react";
import { Row, Col } from "reactstrap";

import PaperList from "./HorizontalList/PaperList";
import CategoryList from "./HorizontalList/CategoryList";
import TopicsList from "./HorizontalList/TopicsList";
import ScenarioList from "./HorizontalList/Scenarios";

import QuestionManagerView from "./QuestionManager/QuestionManagerView";
import PaperViewModal from "../../Tools/PaperGenarator/PaperViewModal";
import {sanitizeAndRenderHTML as renderHTML} from "../../../utils/utils";

import {
  Button,
  ButtonGroup,
  Popover,
  Position,
  Menu,
  MenuItem,
  Alert,
  Intent,
  Collapse,
  Divider,
} from "@blueprintjs/core";

// Data insert Forms
import PaperTypeByGoogle from "../GoogleSheet/PaperTypeByGoogle";
import PaperInsert from "../Form/Papers/PaperInsert";
import PaperEdit from "../Form/Papers/PaperEdit";
import CategoryInsert from "../Form/Category/CategoryInsert";
import CategoryEdit from "../Form/Category/CategoryEdit";
import TopicInsert from "../Form/Topic/TopicInsert";
import TopicEdit from "../Form/Topic/TopicEdit";
// Data Edit Form
import ScenarioEdit from "../Form/Scenario/EditForm/EditForm";

// import Constants
import config from "../../../variables/Constants";
import { AppConfig } from "../../../config/config.js";
import withUseApiService from "../../../utils/withUseApiService.jsx";

// // test
// import SortableComponent from "./QuestionManager/SortableAnswerList";

class PaperManagerView extends Component {
  constructor(props, prevState) {
    super(props, prevState);
    this.apiService = this.props.apiService;
    this.state = {
      isOpen: true,
      //shared data
      // function id 0
      selectedQuestionID: null,
      // function id 1
      selectedModuleID: this.props.moduleId,
      // function id 2
      selectedCategoryID: null,
      // function id 3
      selectedTopicID: null,
      // function id 4
      selectedPaperID: null,
      // function id 5
      selectedScenarioID: null,

      // use for Show google sheet
      showGoogleMainModal: false,

      // data from remote location
      paperTypeData: [],
      categoryData: [],
      topicsData: [],
      questionData: [],
      scenarioData: [],
      PaperInsertCardShow: false,

      // Delete Alert Handle
      PaperTypeDeleteAlertShow: false,

      // selected Data
      selectedPaperTypeData: null,
      selectedPaperCategoryData: null,
      selectedPaperTopicData: null,
      selectedScenarioData: null,

      // loading State Handle
      QuestionLoading: false,
      SelectedPaperType: null,

      // use for drawer visibility handle
      showPaperTypeInsertForm: false,
      showPaperTypeEditForm: false,
      showCategoryInsertForm: false,
      showCategoryEditForm: false,
      showScenarioEditForm: false,
      showTopicInsertForm: false,
      showTopicEditForm: false,

      // use for handle list Loading effect
      PaperTypeLoading: false,
      CategoryLoading: false,
      TopicLoading: false,
      ScenarioLoading: false,

      RowQuestionData: [],
      PaperShow: false,
      GenaratedPaper: [],
      GenaratingPaper: false,
      GenaratingMessage: ""
    };
    // Toggle View
    this.toggleGoogleSheetInsertModalShow = () => {
      this.setState({
        showGoogleMainModal: !this.state.showGoogleMainModal,
      });
    };
    // Pape Type
    this.toggleShowPaperTypeInsertForm = () => {
      this.setState({
        showPaperTypeInsertForm: !this.state.showPaperTypeInsertForm,
      });
    };
    this.toggleShowPaperTypeEditForm = () => {
      this.setState({
        showPaperTypeEditForm: !this.state.showPaperTypeEditForm,
      });
    };
    // Category
    this.toggleShowCategoryInsertForm = () => {
      this.setState({
        showCategoryInsertForm: !this.state.showCategoryInsertForm,
      });
    };
    this.toggleShowCategoryEditForm = () => {
      this.setState({
        showCategoryEditForm: !this.state.showCategoryEditForm,
      });
    };
    // Topics
    this.toggleShowTopicInsertForm = () => {
      this.setState({
        showTopicInsertForm: !this.state.showTopicInsertForm,
      });
    };
    this.toggleShowTopicEditForm = () => {
      this.setState({
        showTopicEditForm: !this.state.showTopicEditForm,
      });
    };

    this.toggleShowScenarioEditForm = () => {
      this.setState({
        showScenarioEditForm: !this.state.showScenarioEditForm,
      });
    };

    // Get Selected data by ID
    this.getSelectedData = (ID) => {
      if ((ID = 1)) {
        this.state.paperTypeData.forEach((element) => {
          if (element.id === this.state.selectedPaperID) {
            this.setState({
              selectedPaperTypeData: element,
              selectedPaperType: element.PaperType,
            });
            //this.FetchSenarioData();
          }
        });
      }
      if ((ID = 2)) {
        this.state.categoryData.forEach((element) => {
          if (element.categoryId === this.state.selectedCategoryID) {
            this.setState({ selectedPaperCategoryData: element });
          }
        });
      }
      if ((ID = 3)) {
        this.state.topicsData.forEach((element) => {
          if (element.topicId === this.state.selectedTopicID) {
            this.setState({ selectedPaperTopicData: element });
          }
        });
      }
      if ((ID = 4)) {
        this.state.scenarioData.forEach((element) => {
          if (element.ScenarioID === this.state.selectedScenarioID) {
            this.setState({ selectedScenarioData: element });
          }
        });
      }
    };

    this.setID = (fucntionId, Id) => {
      if (fucntionId === 0) {
        this.setState({ selectedQuestionID: parseInt(Id, 10) });
      }
      if (fucntionId === 1) {
        this.setState({ selectedModuleID: parseInt(Id, 10) });
      }
      // Category ID Set ------
      if (fucntionId === 2) {
        this.setState(
          {
            selectedCategoryID: Id !== null ? parseInt(Id, 10) : null,
            selectedTopicID: null,
            selectedQuestionID: null,
            selectedPaperTopicData: null,
            selectedPaperCategoryData: null,
          },
          () => {
            if (Id !== null) {
              this.FetchTopicData();
              this.FetchQuestionData(2);
              this.getSelectedData(2);
            } else {
              this.FetchQuestionData(0);
            }
          }
        );
      }
      // Topic ID ----- set
      if (fucntionId === 3) {
        this.setState({ selectedTopicID: parseInt(Id, 10) }, () => {
          this.FetchQuestionData(1);
          this.getSelectedData(3);
        });
      }
      // Paper ID ----- set
      if (fucntionId === 4) {
        this.setState(
          {
            selectedPaperID: Id !== null ? parseInt(Id, 10) : null,
            // selectedCategoryID: null,
            // selectedTopicID: null,
            // selectedQuestionID: null,
            // selectedPaperCategoryData: null,
            // selectedPaperTopicData: null,
            // // selectedScenarioID: null,
            // // selectedScenarioData: null
          },
          () => {
            // this.FetchCategoryData();
            //this.FetchSenarioData();
            if (Id === null) {
              this.setState({ selectedPaperTypeData: null });
            } else {
              this.getSelectedData(1);
            }
            this.FetchQuestionData(0);
          }
        );
      }

      // Scenario ID ----- set
      if (fucntionId === 5) {
        this.setState(
          {
            selectedScenarioID: Id !== null ? parseInt(Id, 10) : null,
          },
          () => {
            this.getSelectedData(4);
            this.FetchQuestionData(0);
          }
        );
      }
    };

    this.doPublish = async () => {
      this.apiService.getApiInstance()
        .patch(
          AppConfig.serviceUrls.papers + this.state.selectedPaperID
        )
        .then((res) => {
          if (res.status === 201) {
            this.props.Notification(
              "tr",
              "success",
              "Paper published successfully",
              "pe-7s-speaker"
            );
          }
          if (res.status === 400) {
            this.props.Notification(
              "tr",
              "error",
              "Error while publishing the paper ",
              "pe-7s-speaker"
            );
          }
        })
        .catch((err) => {
          this.props.Notification(
            "tr",
            "error",
            "Service have been gone offline. ",
            "pe-7s-speaker"
          );
        })
        .finally(() => {
          // this.setState({
          //   uploading: true
          // });
        });
      // }
    };

    // Filter Question Data ------------------------------------------
    this.FilterQuestionData = (QuestionList) => {
      let questionData = [];

      let ScenarioID = this.state.selectedScenarioID;
      let Version =
        this.state.selectedPaperTypeData === null
          ? null
          : this.state.selectedPaperTypeData.Version;
      console.log(ScenarioID, Version);
      QuestionList.forEach((CurrentQuestion) => {
        // notnull and null
        if (ScenarioID !== null && Version === null) {
          if (CurrentQuestion.ScenarioID === ScenarioID) {
            questionData.push(CurrentQuestion);
          }
        } else if (ScenarioID === null && Version !== null) {
          if (CurrentQuestion.versionList.split(",").includes(Version)) {
            questionData.push(CurrentQuestion);
          }
        } else if (ScenarioID !== null && Version !== null) {
          if (
            CurrentQuestion.versionList.split(",").includes(Version) &&
            CurrentQuestion.ScenarioID === ScenarioID
          ) {
            questionData.push(CurrentQuestion);
          }
        } else {
          console.log("Call");
          questionData.push(CurrentQuestion);
        }
      });
      this.setState({ questionData, QuestionLoading: false });
    };
    // --------------------------------------------------------------
    // Fetch Data ---------------------------------------------------
    // PaperType
    this.FetchPaperTypeData = async () => {
      let url = AppConfig.serviceUrls.modules + this.state.selectedModuleID + '/papers';
      this.setState({ PaperTypeLoading: true });
      this.apiService.getApiInstance()
        .get(url)
        .then((res) => {
          if (res.status === 200) {
            this.setState({
              paperTypeData: res.data.papers.length === 0 ? [] : res.data.papers,
              PaperTypeLoading: false,
            });
          } else {
            this.setState({ PaperTypeLoading: false });
          }
        })
        .catch((err) => {
          this.setState({ PaperTypeLoading: false });
        });
    };

    // Category Data
    this.FetchCategoryData = async () => {
      let url =
        AppConfig.serviceUrls.modules + this.state.selectedModuleID + '/categories';
      this.setState({ CategoryLoading: true });
      this.apiService.getApiInstance()
        .get(url)
        .then((res) => {
          if (res.status === 200) {
            this.setState({ categoryData: res.data.categories, CategoryLoading: false });
          } else {
            this.setState({
              CategoryLoading: false,
            });
          }
        })
        .catch((err) => {
          this.setState({
            CategoryLoading: false,
            isError: true,
          });
        });
    };
    // Topic Data
    this.FetchTopicData = async () => {
      let url = AppConfig.serviceUrls.modules + this.state.selectedModuleID + '/categories/' + this.state.selectedCategoryID + '/topics';
      this.setState({ TopicLoading: true });
      this.apiService.getApiInstance()
        .get(url)
        .then((res) => {
          if (res.status === 200) {
            console.log(res.data.topics.length);
            this.setState({
              topicsData: res.data.topics,
              TopicLoading: false,
            });
          } else {
            this.setState({ TopicLoading: false });
          }
        })
        .catch((err) => {
          this.setState({ TopicLoading: false });
        });
    };

    // Question Data
    this.FetchQuestionData = async (value) => {
      // use for refresh question after update
      if (value === 0) {
        if (this.state.selectedTopicID != null) {
          value = 1;
        } else if (this.state.selectedCategoryID != null) {
          value = 2;
        } else {
          value = 3;
        }
      }

      // Normal procedure
      let url = AppConfig.serviceUrls.modules;

      // Topic Level Filter
      if (value === 1) {
        url = url + this.state.selectedModuleID + '/categories/' + this.state.selectedCategoryID +
              '/topics/' + this.state.selectedTopicID + '/questions?questionType=' + this.props.questionType;
      }
      // Category Level Filter
      if (value === 2) {
        url = url + this.state.selectedModuleID + '/categories/' + this.state.selectedCategoryID + 
              '/questions?questionType=' + this.props.questionType;
      }
      // Module Level Filter
      if (value === 3) {
        url = url + this.state.selectedModuleID + '/questions?questionType=' + this.props.questionType;
      }

      this.setState({ QuestionLoading: true });
      this.apiService.getApiInstance()
        .get(url)
        .then((res) => {
          if (res.status === 200) {
            this.FilterQuestionData(res.data);
          } else {
            this.setState({ QuestionLoading: false });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ QuestionLoading: false });
        });
    };

    // Scenario Fetching
    this.FetchSenarioData = async () => {
      let url = AppConfig.serviceUrls.modules + this.state.selectedModuleID + '/scenarios'
      this.setState({
        ScenarioLoading: true,
      });
      this.apiService.getApiInstance()
        .get(url)
        .then((res) => {
          if (res.status === 200) {
            this.setState(
              { scenarioData: res.data.scenarios, ScenarioLoading: false },
              () => {
                this.getSelectedData(4);
              }
            );
            this.console.log(res.data);
          } else {
            this.setState({
              ScenarioLoading: false,
            });
          }
        })
        .catch((err) => {
          this.setState({
            ScenarioLoading: false,
            isError: true,
          });
        });
    };
  }

  // Remove Function
  // Paper Type Remove functions
  PaperTypeDeactive = async (PaperTypeID) => {
    this.apiService.getApiInstance()
      .patch(AppConfig.serviceUrls.paperType + PaperTypeID + "/activation", null
      )
      .then((res) => {
        if (res.status === 201) {
          this.setState(
            {
              // function id 2
              selectedCategoryID: null,
              // function id 3
              selectedTopicID: null,
              // function id 4
              selectedPaperID: null,
              PaperTypeDeleteAlertShow: false,
            },
            () => {
              this.FetchPaperTypeData();
              console.log("Call Fetch");
            }
          );

          this.props.handleClick(
            "tr",
            "success",
            "Paper Type has been removed successfully",
            "pe-7s-speaker"
          );
        }
        if (res.status === 400) {
          this.setState({
            ToggleStateMessage: "Bad Request From Front End",
          });
        }
      })
      .catch((err) => {
        this.setState({
          ToggleStateMessage:
            "Service down check the Server or Check your Connection  ",
        });
      });
  };

  FetchGeneratedPaperData = async () => {
    let url = AppConfig.serviceUrls.modules + this.state.selectedModuleID + '/papers/' + this.state.selectedPaperID;
    this.setState({ GenaratingPaper: true });
    this.apiService.getApiInstance()
      .get(url)
      .then((res) => {
        if (res.status === 200) {
          if (res.data.generatedQuestionSet.length > 0) {
            this.setState({
              GenaratedPaper: res.data,
              GenaratingPaper: false,
              GenaratingMessage: "Generating paper",
            });
            this.handleHide();
          } else {
            this.setState({
              GenaratingPaper: false,
              GenaratingMessage: "Not enough questions in question pool",
            });
          }
        } else {
          this.setState({
            GenaratingPaper: false,
            GenaratingMessage:
              "Error occured",
          });
        }
      })
      .catch((err) => {
        this.setState({
          GenaratingPaper: false,
          GenaratingMessage: "Not enough questions in question pool",
        });
      });
  };

  PaperTypeDeleteAlertOpen = () =>
    this.setState({ PaperTypeDeleteAlertShow: true });

  PaperTypeDeleteAlertClose = () =>
    this.setState({ PaperTypeDeleteAlertShow: false });

  componentDidMount() {
    this.FetchCategoryData();
    this.FetchPaperTypeData();
    this.FetchSenarioData();
  }

  handleHide = () => {
    this.setState({
      PaperShow: !this.state.PaperShow,
      GenaratingMessage: "",
    });
  };

  render() {
    return (
      <Col sm={12} md={12}>
        <PaperTypeByGoogle
          show={this.state.showGoogleMainModal}
          handleHide={this.toggleGoogleSheetInsertModalShow}
          Notification={this.props.Notification}
          dataFetch={this.dataFetch}
          //Module Details
          ModuleName={this.props.moduleName}
          moduleId={this.props.moduleId}
          productId={this.props.productId}
          ProductName={this.props.productName}
          QuestionType={this.props.questionType}
          // -----------------function -----------
          FetchPaperTypeData={() => this.FetchPaperTypeData()}
        />

        {/* Paper Type Insert Drawer */}
        <PaperInsert
          show={this.state.showPaperTypeInsertForm}
          handleHide={this.toggleShowPaperTypeInsertForm}
          dataFetch={this.FetchPaperTypeData}
          Notification={this.props.Notification}
          moduleId={this.props.moduleId}
          productId={this.props.productId}
        />
        {/* Paper Type Edit Drawer */}
        <PaperEdit
          show={this.state.showPaperTypeEditForm}
          handleHide={this.toggleShowPaperTypeEditForm}
          dataFetch={this.FetchPaperTypeData}
          Notification={this.props.Notification}
          moduleId={this.props.moduleId}
          productId={this.props.productId}
          SelectedPaperTypeID={this.state.selectedPaperID}
          selectedPaperTypeData={this.state.selectedPaperTypeData}
        />
        {/* Category Insert Edit Drawer */}
        <CategoryInsert
          show={this.state.showCategoryInsertForm}
          handleHide={this.toggleShowCategoryInsertForm}
          dataFetch={this.FetchCategoryData}
          Notification={this.props.Notification}
          moduleId={this.props.moduleId}
        />
        <CategoryEdit
          show={this.state.showCategoryEditForm}
          handleHide={this.toggleShowCategoryEditForm}
          dataFetch={this.FetchCategoryData}
          Notification={this.props.Notification}
          moduleId={this.props.moduleId}
          CategoryData={this.state.selectedPaperCategoryData}
        />
        <TopicInsert
          show={this.state.showTopicInsertForm}
          handleHide={this.toggleShowTopicInsertForm}
          dataFetch={this.FetchTopicData}
          Notification={this.props.Notification}
          moduleId={this.props.moduleId}
          CategoryID={this.state.selectedCategoryID}
        />
        <TopicEdit
          show={this.state.showTopicEditForm}
          handleHide={this.toggleShowTopicEditForm}
          dataFetch={this.FetchTopicData}
          Notification={this.props.Notification}
          moduleId={this.props.moduleId}
          TopicData={this.state.selectedPaperTopicData}
          CategoryID={this.state.selectedCategoryID}
        />

        <PaperViewModal
          show={this.state.PaperShow}
          handlePaperHide={this.handleHide}
          moduleId={this.state.selectedModuleID}
          PaperID={this.state.selectedPaperID}
          GenaratedPaper={this.state.GenaratedPaper}
        />

        <div autoFocus className={"card"}>
          <div className={"header"}>
            <div className="pull-left">
              <ul className="bp3-breadcrumbs">
                <li>
                  <a
                    className="bp3-breadcrumb"
                    onClick={this.props.TogglePaperWizadMode}
                  >
                    <small>Modules</small>
                  </a>
                </li>

                <li>
                  <a className="bp3-breadcrumb">
                    <small>{this.props.ModuleName}</small>
                  </a>
                </li>
              </ul>
            </div>
            <div className="pull-right">
              <Button
                minimal={true}
                icon={"cross"}
                onClick={this.props.TogglePaperWizadMode}
              />
            </div>
          </div>
          <div className={"content"}>
            <div
              className="row"
              style={{
                marginTop: "-10px",
                margin: "auto",

                background: "white",
              }}
            >
              <Col
                className="col-sm-12"
                style={{
                  paddingRight: "0px",
                  paddingLeft: "0px",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    marginTop: "4px",
                    border: "1px solid lightgray",
                    background: "white",
                    borderRadius: "3px",
                    padding: "12px"
                  }}
                >
                  {/* Paper Type ------------------------------------------------------------------------------ */}
                  <div>
                    <Row style={{ padding: "2px"}}>
                      {this.state.selectedModuleID != null && (
                        <Col sm={12}>
                          <PaperTypeDeleteAlert
                            isOpen={this.state.PaperTypeDeleteAlertShow}
                            handleCancel={this.PaperTypeDeleteAlertClose}
                            handleMoveConfirm={() =>
                              this.PaperTypeDeactive(this.state.selectedPaperID)
                            }
                            PaperTypeName={this.state.paperTypeData.nameOfPaper}
                          />
                          <ButtonGroup
                            minimal={true}
                            disabled={this.state.selectedModuleID === null}
                          >
                            <Button disabled={true} width="100px">
                              <h6 className=".bp3-heading .bp3-text-muted">
                                Papers
                              </h6>
                            </Button>
                            <Button
                              icon="add"
                              onClick={this.toggleShowPaperTypeInsertForm}
                            >
                              Add New
                            </Button>
                            <Button
                              icon="panel-table"
                              onClick={this.toggleGoogleSheetInsertModalShow}
                            >
                              Add Question Pool
                            </Button>
                            <Divider />
                            <Popover
                              content={
                                <Menu>
                                  {this.state.selectedPaperTypeData && (
                                    <MenuItem
                                      disabled={
                                        this.state.selectedPaperID === null
                                      }
                                      icon={
                                        this.state.selectedPaperTypeData
                                          .publishState !== "PUBLISHED"
                                          ? "share"
                                          : "ban-circle"
                                      }
                                      intent={
                                        this.state.selectedPaperTypeData
                                          .publishState === "PUBLISHED"
                                          ? "danger"
                                          : "success"
                                      }
                                      text={
                                        this.state.selectedPaperTypeData
                                          .publishState !== "PUBLISHED"
                                          ? "Published"
                                          : "Unpublished"
                                      }
                                      onClick={this.doPublish}
                                    />
                                  )}
                                  <MenuItem
                                    disabled={
                                      this.state.selectedPaperID === null &&
                                      this.state.selectedPaperTypeData === null
                                    }
                                    onClick={this.toggleShowPaperTypeEditForm}
                                    icon="edit"
                                    text="Edit"
                                  />
                                  <MenuItem
                                    disabled={
                                      this.state.selectedPaperID === null
                                    }
                                    icon="trash"
                                    intent="danger"
                                    text="Delete"
                                    onClick={this.PaperTypeDeleteAlertOpen}
                                  />
                                </Menu>
                              }
                              position={Position.RIGHT_TOP}
                            >
                              <Button
                                icon="cog"
                                text="Setting"
                                rightIcon="caret-down"
                              />
                            </Popover>
                            <Button
                              icon="refresh"
                              onClick={this.FetchPaperTypeData}
                            >
                              Refresh
                            </Button>
                            <Button onClick={this.FetchGeneratedPaperData}>
                              Generate Paper
                            </Button>
                          </ButtonGroup>
                        </Col>
                      )}
                    </Row>
                    <Row style={{ marginTop: "15px" }}>
                      <Col sm={12} style={{ height: "103px" }}>
                        <PaperList
                          selectedModuleID={this.state.selectedModuleID}
                          paperTypeData={this.state.paperTypeData}
                          setID={this.setID}
                          loading={this.state.PaperTypeLoading}
                        />
                      </Col>
                    </Row>
                  </div>
                  {/* End Paper Type ------------------------------------------------------------------ */}
                  <hr style={{ marginTop: "30px" }} />
                  {/* Category view----------------------------------------------------------------------- */}
                  <Row style={{ padding: "2px" }}>
                    <Col sm={12}>
                      <ButtonGroup minimal={true}>
                        <Button disabled={true}>
                          <h6 className=".bp3-heading .bp3-text-muted">
                            Categories
                          </h6>
                        </Button>
                        <Button
                          icon="add"
                          onClick={this.toggleShowCategoryInsertForm}
                        >
                          Add New
                        </Button>
                        <Popover
                          content={
                            <Menu>
                              <MenuItem
                                disabled={
                                  this.state.selectedCategoryID === null
                                }
                                onClick={this.toggleShowCategoryEditForm}
                                icon="edit"
                                text="Edit"
                              />
                              <MenuItem
                                disabled={
                                  this.state.selectedCategoryID === null
                                }
                                icon="trash"
                                intent="danger"
                                text="Delete"
                              />
                            </Menu>
                          }
                          position={Position.RIGHT_TOP}
                        >
                          <Button
                            icon="cog"
                            text="Setting"
                            rightIcon="caret-down"
                          />
                        </Popover>
                      </ButtonGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12} style={{ height: "86px" }}>
                      <CategoryList
                        selectedModuleID={this.state.selectedModuleID}
                        categoryData={this.state.categoryData}
                        setID={this.setID}
                        loading={this.state.CategoryLoading}
                      />
                    </Col>
                  </Row>

                  {/* End Category ---------------------------------------------------------------- */}
                  <hr style={{ marginTop: "30px" }} />
                  {/* Topic View --------------------------------------------------------------------- */}
                  <Row style={{ padding: "2px" }}>
                    <Col sm={12}>
                      <ButtonGroup minimal={true}>
                        <Button disabled={true}>
                          <h6 className=".bp3-heading .bp3-text-muted">
                            Topics
                          </h6>
                        </Button>

                        {/* <div> */}
                        <Button
                          icon="add"
                          disabled={this.state.selectedCategoryID === null}
                          onClick={this.toggleShowTopicInsertForm}
                        >
                          Add New
                        </Button>
                        <Popover
                          content={
                            <Menu>
                              <MenuItem
                                disabled={this.state.selectedTopicID === null}
                                icon="edit"
                                text="Edit"
                                onClick={this.toggleShowTopicEditForm}
                              />
                              <MenuItem
                                disabled={this.state.selectedTopicID === null}
                                icon="trash"
                                intent="danger"
                                text="Delete"
                              />
                            </Menu>
                          }
                          position={Position.RIGHT_TOP}
                        >
                          <Button
                            icon="cog"
                            text="Setting"
                            rightIcon="caret-down"
                          />
                        </Popover>
                        {/* </div> */}
                        

                      </ButtonGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12} style={{ height: "86px" }}>
                      <TopicsList
                        selectedPaperID={this.state.selectedPaperID}
                        selectedCategoryID={this.state.selectedCategoryID}
                        topicsData={this.state.topicsData}
                        setID={this.setID}
                        loading={this.state.TopicLoading}
                      />
                    </Col>
                  </Row>
                  {/* End Topic View */}

                  {/* Scenario View --------------------------------------------------------------------- */}
                  {this.props.QuestionType === "SCENARIO_BASE" && (
                    <div style={{ background: "#EFEEEE" }}>
                      <hr style={{ margin: "2px" }} />

                      <Row style={{ padding: "2px" }}>
                        <Col sm={12}>
                          <ButtonGroup minimal={true}>
                            <Button disabled={true} width="100px">
                              <h6 className=".bp3-heading .bp3-text-muted">
                                Scenarios
                              </h6>
                            </Button>
                            <Button icon="add" title="for add new Scenario">
                              Add New
                            </Button>
                            {/* <Button
                              title="More Inforomation"
                              icon="more"
                              disabled={this.state.selectedScenarioID === null}
                            /> */}
                          </ButtonGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={12} style={{ height: "86px" }}>
                          <ScenarioList
                            selectedPaperID={this.state.selectedPaperID}
                            scenarioData={this.state.scenarioData}
                            setID={this.setID}
                            loading={this.state.ScenarioLoading}
                          />
                        </Col>
                      </Row>
                    </div>
                  )}
                  {/* Scenario End View--------------------------------------------------------------------- */}
                </div>
              </Col>
            </div>

            {this.state.selectedScenarioData !== null &&
              this.state.selectedScenarioID !== null && (
                <Col sm={12} md={12}>
                  <ScenarioEdit
                    show={this.state.showScenarioEditForm}
                    onClose={this.toggleShowScenarioEditForm}
                    data={this.state.selectedScenarioData}
                    ScenarioID={this.state.selectedScenarioID}
                    dataFetch={this.FetchSenarioData}
                    Notification={this.props.Notification}
                  />
                  {/* <ScenarioInsert
                    show={this.state.showScenarioForm}
                    onClose={this.toggleShowScenarioEditForm}
                    data={this.state.selectedScenarioData}
                    ScenarioID={this.state.selectedScenarioID}
                    dataFetch={this.FetchSenarioData}
                    Notification={this.props.Notification}
                  /> */}
                  <div className="row" style={{ paddingTop: "10px" }}>
                    <div autoFocus className={"card"}>
                      <div className={"header"}>
                        <div className="pull-left">
                          <p className="category"> Scenario Viewer</p>
                        </div>
                        <div className="pull-right">
                          <ButtonGroup>
                            <Button
                              minimal={true}
                              title=" For Edit Selected senario details"
                              icon={"edit"}
                              onClick={this.toggleShowScenarioEditForm}
                            />
                            <Button
                              minimal={true}
                              title=" For show Selected senario details"
                              icon={
                                this.state.isOpen
                                  ? "chevron-up"
                                  : "chevron-down"
                              }
                              onClick={() => {
                                this.setState({ isOpen: !this.state.isOpen });
                              }}
                            />
                          </ButtonGroup>
                        </div>
                      </div>
                      <br />
                      <Collapse isOpen={this.state.isOpen}>
                        <hr />
                        <div className="content">
                          <Row>
                            <Col sm={12}>
                              <b>Scenario: </b>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={12}>
                              {renderHTML(
                                this.state.selectedScenarioData.Scenario
                              )}
                            </Col>
                          </Row>
                          <br />
                          <Row>
                            <Col sm={12}>
                              {" "}
                              <b>Image:</b>
                            </Col>
                            <Col sm={12}>
                              {this.state.selectedScenarioData.OtherContent !==
                              null ? (
                                <img
                                  // className="zoom"
                                  style={{
                                    border: "1px solid #ddd",
                                    border_radius: "4px",
                                    width: "100px",
                                  }}
                                  alt="Question Other Content"
                                  src={
                                    this.state.selectedScenarioData.OtherContent
                                  }
                                />
                              ) : (
                                <p className="category">No Image Data</p>
                              )}
                            </Col>
                          </Row>
                        </div>
                      </Collapse>
                      <br />
                    </div>
                  </div>
                </Col>
              )}

            {/* Question View --------------------------------------------- */}
            <div className="row" style={{ paddingTop: "5px" }}>
              <div>
                <QuestionManagerView
                  questionData={this.state.questionData}
                  QuestionLoading={this.state.QuestionLoading}
                  FetchQuestionData={this.FetchQuestionData}
                  setID={this.setID}
                  selectedData={[
                    this.state.selectedPaperTypeData,
                    this.state.selectedPaperCategoryData,
                    this.state.selectedPaperTopicData,
                  ]}
                  selectedIDs={[
                    this.state.selectedModuleID,
                    this.state.selectedPaperID,
                    this.state.selectedCategoryID,
                    this.state.selectedTopicID,
                    this.state.selectedScenarioID,
                  ]}
                  moduleId={this.props.moduleId}
                  TopicID={this.state.selectedTopicID}
                  productId={this.props.productId}
                  //Identify PaperType
                  questionType={this.props.questionType}
                  // Notification Handle
                  Notification={this.props.Notification}
                />
              </div>
            </div>

            {/* End Question View ----------------------------------------- */}
          </div>
          <div className="clearfix" />
        </div>
      </Col>
    );
  }
}

export default withUseApiService(PaperManagerView);

// Delete alert Message
function PaperTypeDeleteAlert(props) {
  return (
    <Alert
      cancelButtonText="Cancel"
      confirmButtonText="Move to Trash"
      icon="trash"
      intent={Intent.DANGER}
      isOpen={props.isOpen}
      onCancel={props.handleCancel}
      onConfirm={props.handleMoveConfirm}
    >
      <p>
        Are you sure you want to move <b>{props.PaperTypeName}</b> to Trash? You
        will be not able to restore it later.
      </p>
    </Alert>
  );
}
